import React, {Component} from 'react';

export default class Error extends Component {

	render() {
		if(!this.props.err) return null;

		return (
	    	<div className={"alert alert-dismissable " + (this.props.status === 'err'? 'alert-danger' : 'alert-success')}>
				<a className="close" data-dismiss="alert" aria-label="close">&times;</a>
				<strong>{this.props.status === 'err'? 'Warning' : 'Success'}!</strong> {this.props.err}
			</div>
		);

	}
}


// WEBPACK FOOTER //
// ./src/helpers/Error.js